import { produce, castDraft, type Draft } from "immer";
import { type GetCachedLensListV2Query, type GetLensListV2Query } from "../query";

export const LensesOperationsV2 = {
    concat(prevLenses: GetCachedLensListV2Query, nextLenses: GetLensListV2Query) {
        if (!nextLenses) {
            return prevLenses;
        }

        return produce(prevLenses, (draft: Draft<GetCachedLensListV2Query>) => {
            draft.getLensListV2!.cursor = nextLenses.getLensListV2?.cursor ?? "";
            draft.getLensListV2!.lensesWithConnections!.push(
                ...castDraft(nextLenses!.getLensListV2!.lensesWithConnections ?? []),
            );
        });
    },
};
